import React from "react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useNavigate } from "react-router-dom";
import { useGetOrganisationsQuery } from "@/store/rest_api";

const Organisations = () => {
  const { data: organisations } = useGetOrganisationsQuery();

  const navigate = useNavigate();

  if (!organisations || !organisations.length) {
    return (
      <div className="p-4">
        <Button
          className="mb-2"
          onClick={() => {
            navigate("/settings/organisations/new");
          }}
        >
          New organisation
        </Button>
      </div>
    );
  }

  return (
    <div className="p-4">
      <Button
        className="mb-2"
        onClick={() => {
          navigate("/settings/organisations/new");
        }}
      >
        New organisation
      </Button>
      <Table>
        <TableCaption>A list of your organisations.</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Website</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {organisations.map((organisation) => (
            <TableRow key={`lead-${organisation.id}`}>
              <TableCell className="font-medium">{organisation.id}</TableCell>
              <TableCell>{organisation.name}</TableCell>
              <TableCell>{organisation.description}</TableCell>
              <TableCell>{organisation.website}</TableCell>
              <TableCell className="text-right">
                <Button onClick={() => {}}>Action</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default Organisations;
